// extracted by mini-css-extract-plugin
export default {"enrollmentIcon":"Enrollment_enrollmentIcon__qRTuj","container":"Enrollment_container__TdLuN","uploadBtn":"Enrollment_uploadBtn__ROEf6"};